import { Navigate, Route, Routes } from 'react-router-dom';
import {
  ACCOUNT_PATH,
  B2B_ORDERS_PATH,
  B2C_LEGACY_ORDERS_PATH,
  B2C_ORDERS_PATH,
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  LOGIN_PATH,
  REPORTS_PATH,
  RESET_PASSWORD_PATH,
} from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import {
  B2Borders,
  B2Corders,
  B2COrdersV2,
  ForgotPassword,
  Login,
  NotFound,
  ReportsIndex,
  ResetPassword,
} from '~/routes';
import { AuthenticatedLayout } from './components/organisms/AuthenticatedLayout';
import { UnauthenticatedLayout } from './components/organisms/UnauthenticatedLayout';
import { AuthRedirect } from './components/utilities/AuthRedirect';
import { RequireAuth } from './components/utilities/RequireAuth';

function App() {
  const { flags } = useFeatureFlags();
  const enableReplenishmentOrdersView = flags['enable_replenishment_orders_view'];
  const exposeLegacyOrders = flags['expose_legacy_orders'];

  return (
    <Routes>
      {/* Authenticated Routes */}
      <Route element={<RequireAuth />}>
        <Route element={<AuthenticatedLayout />}>
          <Route path={HOME_PATH} element={<Navigate to={B2C_ORDERS_PATH} replace />} />
          <Route path={B2C_ORDERS_PATH} element={enableReplenishmentOrdersView ? <B2COrdersV2 /> : <B2Corders />} />
          {exposeLegacyOrders && <Route path={B2C_LEGACY_ORDERS_PATH} element={<B2Corders />} />}
          <Route path={B2B_ORDERS_PATH} element={<B2Borders />} />

          {/* QuickSight reports */}
          <Route path={REPORTS_PATH} element={<ReportsIndex />} />
        </Route>
      </Route>

      {/* Unauthenticated Routes */}
      <Route element={<AuthRedirect />}>
        <Route element={<UnauthenticatedLayout />}>
          <Route path={ACCOUNT_PATH}>
            <Route path={LOGIN_PATH} element={<Login />} />
            <Route path={FORGOT_PASSWORD_PATH} element={<ForgotPassword />} />
            <Route path={RESET_PASSWORD_PATH} element={<ResetPassword />} />
          </Route>
        </Route>
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
